import { Component, OnInit } from '@angular/core';
import { ApiService } from '../api.service';
import { Router } from '@angular/router';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { HandlerService } from '../handler.service';
import { AuthService } from '../auth.service';
import { DomSanitizer } from '@angular/platform-browser';
import { BottomSheet } from '../bottom.sheet';
import { ThumbnailService } from '../thumbnail.service';
let k=1,j=90;
@Component({
  selector: 'app-manage-subscriptions',
  templateUrl: './manage-subscriptions.component.html',
  styleUrls: ['./manage-subscriptions.component.scss'],
})
export class ManageSubscriptionsComponent {

  loader:boolean = true;
  change:boolean;
  storeObj;
  search:any=[];
  filterLength;
  subsObj;
  url;
  pageEnd:boolean=false;
  id;userObject:any=[];firstName;userId;users:any=[];Name;UserId;orgId;
  constructor(public service: ApiService,
    public router: Router,
    public handler: HandlerService,
    public auth: AuthService,
    public santinzer:DomSanitizer,
    private bottomSheet: MatBottomSheet,
    public thumb:ThumbnailService
   ) { }

   ionViewWillEnter(){
     this.url = window.location.href;
     this.getSubscription(); 
 
   }


  getSubscription(){
  this.service.getAllSubscriptions().subscribe((res:any)=>{
    if(res){
      this.subsObj = res;
      this.subsObj =this.subsObj.filter(res=>{return res.packageInd==true})
      this.subsObj.map(dat=>{
        if(dat.imageId){
          this.thumb.getThumbIcon(dat)
        }
      })
      this.loader = false;
    }else{
      this.handler.res("No Data Found");
      this.loader = false;
   
    }
  
 },err =>{
   this.handler.err(err)
   this.loader = false;
 })
   }


   getId(dat){
    dat.select=!dat.select
    var x =  this.subsObj.filter(res => { return res.select == true });
   }

  editSubscription(id){
    this.router.navigate(['edit-subs/',+id])
  }
  // route(){
  //   this.router.navigate(['/vendorDetails'])  
  //  }
  vendoruser(){
    this.service.getUsersByOrg('SC',this.id,null).subscribe(res => {
      this.users = res;
   })
  }
  deleteSubscriptions(id){
    this.loader=true;
    this.service.deleteSubscription(id).subscribe(res=>{
      this.loader=false;
      this.handler.res("Deleted successfully")
      this.getSubscription();
      this.router.navigate(['/manageSubscriptions'])
    },
    err=>{
      this.handler.err(err)
      this.loader=false
    })
  } 
 
  openBottomSheetVendor(): void {
    const dialogRef = this.bottomSheet.open(BottomSheet,{
      data: this.users,
    });
    dialogRef.afterDismissed().subscribe((res) => {
      this.Name = res.firstName;
      this.UserId=res.userId;
    });
  }
  ionViewWillLeave(){
    this.search = "";
  }

  refreshData(event){
    this.loader = true; 
    this.ionViewWillEnter();
    setTimeout(() => {
      event.target.complete();
    }, 1000);
  }
  clear(){
    this.search="";
  }
  ngDoCheck(): void {
    this.filterLength = sessionStorage.getItem('len')
  
  }
}
